import { cn } from '@repo/lib/cn';
import { ClockCheckIcon, ClockFadingIcon, FileEditIcon, MoreVerticalIcon, Trash2Icon } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { DropdownMenu, DropdownMenuContent, DropdownMenuGroup, DropdownMenuItem, DropdownMenuSeparator, DropdownMenuTrigger } from '@/components/ui/dropdown-menu';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip/Tooltip';
import { useMediaQuery } from '@/hooks/media-query';

interface EventActionButtonGroupProps {
  onEdit: () => void;
  onDelete: () => void;
  onCancel: () => void;
  isCancelled: boolean;
  className?: string;
}

export default function EventActionButtonGroup(eventActionButtonGroupProps: EventActionButtonGroupProps) {
  const { onEdit, onDelete, onCancel, isCancelled, className } = eventActionButtonGroupProps;
  const breakpoint = useMediaQuery('md');

  if (breakpoint) {
    return (
      <div className={cn('flex gap-0.5', className)}>
        <Tooltip>
          <TooltipTrigger asChild>
            <Button variant={'ghost'} size={'sm'} onClick={onEdit}>
              <FileEditIcon />
            </Button>
          </TooltipTrigger>
          <TooltipContent>Edytuj</TooltipContent>
        </Tooltip>

        <Tooltip>
          <TooltipTrigger asChild>
            <Button variant={'ghost'} size={'sm'} onClick={onCancel}>
              {isCancelled ? <ClockCheckIcon /> : <ClockFadingIcon />}
            </Button>
          </TooltipTrigger>
          <TooltipContent>{isCancelled ? 'Przywróć' : 'Odwołaj'}</TooltipContent>
        </Tooltip>

        <Tooltip>
          <TooltipTrigger asChild>
            <Button variant={'ghost'} size={'sm'} variantColor={'destructive'} onClick={onDelete}>
              <Trash2Icon />
            </Button>
          </TooltipTrigger>
          <TooltipContent>Usuń</TooltipContent>
        </Tooltip>
      </div>
    );
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant={'ghost'} size={'sm'} className={className}>
          <MoreVerticalIcon />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align={'end'}>
        <DropdownMenuGroup>
          <DropdownMenuItem onClick={onEdit}>
            <FileEditIcon />
            Edytuj
          </DropdownMenuItem>
        </DropdownMenuGroup>
        <DropdownMenuSeparator />
        <DropdownMenuGroup>
          <DropdownMenuItem variant={'destructive'} onClick={onDelete}>
            <Trash2Icon />
            Usuń
          </DropdownMenuItem>
          <DropdownMenuItem onClick={onCancel} variant={'destructive'}>
            {isCancelled ? (
              <>
                <ClockCheckIcon /> Przywróć
              </>
            ) : (
              <>
                <ClockFadingIcon /> Odwołaj
              </>
            )}
          </DropdownMenuItem>
        </DropdownMenuGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
